module.exports = __webpack_public_path__ + "img/menu-icon-mails.81844205.svg";